import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VehicleModelsService } from './vehicle-models.service';
import { DataService } from '../data.service';
import { ConstantsService } from '../constants.service';
import { ToastMessage } from '../toast-message/toast-message.service';

@Component({
  selector: 'app-vehicle-model-edit',
  template: require('./vehicle-model-edit.component.html')
})
export class VehicleModelEditComponent implements OnInit {
  id: string = '';
  model: string = '';
  manufacturer: string = '';
  displayName: string = '';
  active: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private vmService: VehicleModelsService, private dataService: DataService, private constantService: ConstantsService, private toast: ToastMessage) {}

  ngOnInit() {
    this.id = this.route.snapshot.params && this.route.snapshot.params['id'] || '';
    this.model = this.route.snapshot.queryParamMap.get('model') || '';
    this.manufacturer = this.route.snapshot.queryParamMap.get('manufacturer') || '';
    this.displayName = this.route.snapshot.queryParamMap.get('displayName') || '';
    const qpActive = this.route.snapshot.queryParamMap.get('active');
    if (qpActive !== null && qpActive !== undefined && qpActive !== '') {
      this.active = String(qpActive).toLowerCase() === 'true';
    }
  }

  onUpdate() {
    // Auth check for edit on action
    const editRole = this.constantService.vehicleModelPermissions.edit;
    if (!this.userHasRole(editRole)) {
      this.toast.openSnackBarError('You are not authorized to edit vehicle models');
      return;
    }
    const payload = {
      manufacturer: this.manufacturer || '',
      model: this.model || '',
      displayName: this.displayName || '',
      active: !!this.active
    };
    this.vmService.updateVehicleModel(this.id, payload).subscribe(
      (res) => {
        // Basic success handling
        // Navigate back to list; you can replace with proper toast if needed
        this.router.navigate(['/vehicle-models'], { queryParamsHandling: 'preserve' });
      },
      (err) => {
        // Optionally show error; keeping simple
        console.error('Update vehicle model failed', err);
      }
    );
  }

  private userHasRole(role: string): boolean {
    const accessRoles = this.dataService.accessCookie('accessRoles') || '';
    const roles = accessRoles ? accessRoles.split(',') : [];
    return Array.isArray(roles) && roles.indexOf(role) > -1;
  }

  onBack() {
    this.router.navigate(['/vehicle-models'], { queryParamsHandling: 'preserve' });
  }
}


